import { memberDTOSchema, pricePreviewDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const memberEnvelopeSchema = dataEnvelopeSchema(memberDTOSchema);
const pricePreviewEnvelopeSchema = dataEnvelopeSchema(pricePreviewDTOSchema);
const listMembersSchema = listEnvelopeSchema(memberDTOSchema);
export function createMembersResource(transport) {
    return {
        async previewPriceChange(delta) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/members/price-preview`,
                schema: pricePreviewEnvelopeSchema,
                body: { kind: 'quantity', dimension: 'SEAT', delta },
            });
            return envelope.data;
        },
        async invite(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/members/invite`,
                schema: memberEnvelopeSchema,
                body: input,
            });
            return envelope.data;
        },
        async list(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/members`,
                schema: listMembersSchema,
                query: {
                    page: params.page,
                    pageSize: params.pageSize,
                    sort: params.sort,
                    status: params.status,
                    q: params.q,
                },
            });
        },
        async get(membershipId) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/members/${encodeURIComponent(membershipId)}`,
                schema: memberEnvelopeSchema,
            });
            return envelope.data;
        },
        async setRoles(membershipId, input) {
            const envelope = await transport.request({
                method: 'PUT',
                path: `${WEB_API_PREFIX}/members/${encodeURIComponent(membershipId)}/roles`,
                schema: memberEnvelopeSchema,
                body: input,
            });
            return envelope.data;
        },
        async resendInvite(membershipId) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/members/${encodeURIComponent(membershipId)}/invite/resend`,
                schema: memberEnvelopeSchema,
            });
            return envelope.data;
        },
        async revokeInvite(membershipId) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/members/${encodeURIComponent(membershipId)}/invite/revoke`,
                schema: memberEnvelopeSchema,
            });
            return envelope.data;
        },
        async updateStatus(membershipId, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: `${WEB_API_PREFIX}/members/${encodeURIComponent(membershipId)}/status`,
                schema: memberEnvelopeSchema,
                body: input,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=members.js.map